<template>
    <Dialog size="small">
        <template v-slot:title>
            <span>無線機管理ユーザーの権限編集</span>
        </template>
        <template v-slot:body>
            <div class="dialog-content">
                <p style="margin-bottom: 20px;">
                    無線機管理ユーザーに付与する権限を編集できます。
                </p>

                <el-form class="dialog-form-item" >

                    <!-- テナント管理権限 -->
                    <el-form-item style="text-align:right">
                        <div slot="label" style="text-align:left">
                            <span>テナント管理</span>
                        </div>
                        <el-switch
                            v-model="permissions.consoleManagementTenantManagement"
                            active-color="#5171cb"
                        ></el-switch>
                        <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px;">
                            <div slot="content" style="text-align:left">テナント管理権限を付与します。</div>
                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                        </el-tooltip>
                    </el-form-item>

                    <!-- 動態管理の参照 -->
                    <el-form-item style="text-align:right">
                        <div slot="label" style="text-align:left">
                            <span v-t="'message.item_reference_for_location_tracking'"></span>
                        </div>
                        <el-switch
                            v-model="permissions.consoleManagementTracking"
                            active-color="#5171cb"
                        ></el-switch>
                        <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px;">
                            <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_consnole_permission_tracking')"></div>
                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                        </el-tooltip>
                    </el-form-item>

                    <!--- コンソール操作権限 --->
                    <template>

                        <!-- ユーザー、グループの作成 -->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_console_operation_permissions'"></span>
                            </div>
                            <el-checkbox
                                v-model="permissions.consoleManagementEditUserAndTalkGroupDefinition"
                            >
                                {{ $t('message.item_create_user_group') }}
                            </el-checkbox>
                            <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_consnole_permission_edit_user_and_group_definition')"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </el-form-item>

                        <!-- ユーザーをグループに追加 -->
                        <el-form-item style="text-align:right">
                            <div slot="label" style="text-align:left"></div>
                            <el-checkbox
                                v-model="permissions.consoleManagementEditUserTalkGroupAssignment"
                            >
                                {{ $t('message.item_edit_user_talk_group') }}
                            </el-checkbox>
                            <el-tooltip effect="dark" placement="top-start" style="padding-left: 5px">
                                <div slot="content" style="text-align:left" v-html="$t('message.error_radio_integrate_general_admin_hint_consnole_permission_edit_user_talkgroup_assignment')"></div>
                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                            </el-tooltip>
                        </el-form-item>

                    </template>

                </el-form>
            </div>
        </template>
        <template v-slot:button>
            <button class="cancel-button" @click="handleCancel">キャンセル</button>
            <button class="save-button" @click="handleSave">保存</button>
        </template>
    </Dialog>
</template>

<script>
import Vue from 'vue'
import server from './ServerApi.js';
import commonUtil from './commonutil.js';
import constants from './constants.js';
import Dialog from './pc/common/Dialog.vue';

export default {
    components: {
        Dialog
    },

    props: {
        tenantName: {
            type: String,
            required: true
        },
        currentPermissions: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            permissions: {
                consoleManagementTracking: this.currentPermissions.consoleManagementTracking || false,
                consoleManagementEditUserAndTalkGroupDefinition: this.currentPermissions.consoleManagementEditUserAndTalkGroupDefinition || false,
                consoleManagementEditUserTalkGroupAssignment: this.currentPermissions.consoleManagementEditUserTalkGroupAssignment || false,
                consoleManagementTenantManagement: this.currentPermissions.consoleManagementTenantManagement || false
            }
        };
    },

    methods: {
        handleCancel() {
            this.$emit('cancel');
        },

        handleSave() {
            this.$emit("save", this.permissions)
        }
    }
};
</script>

<style scoped>
.dialog-content {
    padding: 20px;
}

.permission-option {
    margin-bottom: 15px;
}

.permission-option label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
}

.permission-option input[type="radio"] {
    margin-right: 10px;
    cursor: pointer;
}

.permission-option span {
    color: #333;
}

.cancel-button,
.save-button {
    padding: 8px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s;
    margin-left: 10px;
}

.cancel-button {
    background-color: #f0f0f0;
    color: #333;
}

.cancel-button:hover {
    background-color: #e0e0e0;
}

.save-button {
    background-color: #409eff;
    color: white;
}

.save-button:hover {
    background-color: #3a8ee6;
}
</style>
